const STORAGE_KEY = 'last_used_org_id';

export const getLastUsedOrgId = (): string | null => localStorage.getItem(STORAGE_KEY);

export const setLastUsedOrgId = (orgId: string): void => localStorage.setItem(STORAGE_KEY, orgId);

export const clearLastUsedOrgId = (): void => localStorage.removeItem(STORAGE_KEY);
